import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { XClose } from "untitledui-js-base";
import Drawer from "react-modern-drawer";
import { useFacetController } from "views/renters/components/FilterDrawer/useFacetController";
import { Facets } from "views/renters/components/FilterDrawer/Facets";
import { RentPrice } from "views/renters/components/FilterDrawer/RentPrice";
import { useClearRefinements } from "react-instantsearch-core";

type Props = {
  showFilters: boolean;
  setShowFilters: (value: boolean) => void;
  clearSelectedRows: () => void;
};

const filters = [
  {
    title: "City",
    property: "property.city"
  },
  {
    title: "Property",
    property: "property.name"
  },
  {
    title: "Renter's Status",
    property: "status"
  }
];

export const FiltersDrawer = ({
  showFilters,
  setShowFilters,
  clearSelectedRows
}: Props) => {
  const facetControllers = useFacetController();
  const { refine: clear } = useClearRefinements({
    excludedAttributes: ["boomEnrollmentStatus"]
  });

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      onClose={() => {
        setShowFilters(false);
      }}
      open={showFilters}
      size={360}
    >
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-alpha-80 px-6 py-4">
          <p className="text-xl font-bold text-content-1000">Filters</p>
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            borderLess
            className="!justify-end stroke-content-1000 !p-0"
            onClick={() => setShowFilters(false)}
          >
            <XClose size="24" />
          </Button>
        </div>
        <div className="mx-6 border-b border-alpha-80 py-4">
          <Button variant={ButtonVariant.TEXT} onClick={() => clear()}>
            Clear All
          </Button>
        </div>
        <div className="flex flex-grow flex-col gap-4 overflow-y-auto px-6 py-4">
          {filters.map((filter) => {
            const controller = facetControllers[filter.property];
            return (
              <Facets
                key={filter.title}
                title={filter.title}
                facetController={controller}
                clearSelectedRows={clearSelectedRows}
              />
            );
          })}

          <RentPrice clearSelectedRows={clearSelectedRows} />
        </div>
      </div>
    </Drawer>
  );
};
